import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Modal } from '../../../components';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import { checkRootAccess } from '../../modulos/modules.helpers';
import {
  getAllTiposNivelClasesAction,
  setActivoTiposNivelClasesAction,
} from './TiposNivelClasesAction';
import FormTiposNivelClases from './components/FormTiposNivelClases';
import ListadoTiposNivelClases from './components/ListadoTiposNivelClases';

const TiposNivelClasesView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposNivelClasesStore = Redux.useSelector(
    (state) => state.tiposNivelClases
  );

  const loginStore = Redux.useSelector((state) => state.login);
  checkRootAccess(loginStore);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoTiposNivelClasesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          azul
          mr={2}
        />
        {tiposNivelClasesStore.all.length > 0 ? (
          <BotonNuevoComponent
            click={async () => {
              await setActivoTiposNivelClasesAction(dispatch, null);
              await getAllTiposNivelClasesAction(
                dispatch,
                entidadesStore.activo.id
              );
            }}
            disabled={tiposNivelClasesStore.loadingGetAll}
            white
            text={
              tiposNivelClasesStore.loadingGetAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoTiposNivelClases
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <Modal
        id="modalFormTiposNivelClases"
        title={`${
          tiposNivelClasesStore.activo ? 'Editar' : 'Nuevo'
        } nivel de clase`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tiposNivelClasesStore.activo ? (
          <Typography variant="h6">
            {tiposNivelClasesStore.activo.nombres}{' '}
            {tiposNivelClasesStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormTiposNivelClases
          activo={tiposNivelClasesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default TiposNivelClasesView;
